import redirects from './redirect';
import * as permission from 'common-module/src/config/permission';

const redirectRoutes = Object.keys(redirects).map(key => ({
  path: key,
  redirect: redirects[key],
  meta: {
    hidden: true
  }
}));
export default [ ...redirectRoutes, {
  name: 'kanban',
  path: '/kanban/list',
  icon: 'zkicon iconsprint',
  meta: {
    micro: 'kanban',
    title: 'route.sprint_track',
    simple: true,
    background: '#f5f5f7',
    noAccessUrl: 'insights'
  }
}, {
  name: 'kanban-share',
  path: '/kanban/share',
  meta: {
    micro: 'kanban',
    title: 'route.Kanban',
    share: true,
    hidden: true,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'backlog-list',
  path: '/backlog/list',
  icon: 'zkicon iconbacklog',
  meta: {
    micro: 'backlog',
    title: 'route.Backlog',
    ...permission.backlogPage,
    background: '#f6f6f9',
    simple: true
  }
}, {
  name: 'issue-list',
  path: '/work/list',
  icon: 'zkicon iconissue',
  meta: {
    micro: 'work',
    title: 'route.Issues',
    background: '#ffffff',
    simple: true
  }
}, {
  name: 'issue-airtable',
  path: '/work/table',
  icon: 'zkicon iconissue',
  meta: {
    micro: 'issue',
    title: 'route.Issues',
    background: '#ffffff',
    simple: true
  }
}, {
  name: 'issue-import',
  path: '/work/issue-import',
  icon: 'zkicon iconissue',
  meta: {
    micro: 'work',
    title: 'route.Issues',
    background: '#ffffff',
    ...permission.issueImportPage,
    simple: true
  }
},
{
  name: 'comment-import',
  path: '/work/comment-import',
  icon: 'zkicon iconissue',
  meta: {
    micro: 'work',
    title: 'route.Issues',
    background: '#ffffff',
    ...permission.commentImportPage,
    simple: true
  }
},
{
  name: 'issue-view-recorder',
  path: '/work/view-recorder',
  meta: {
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'epic-list',
  path: '/epic/list',
  icon: 'zkicon iconepic',
  meta: {
    micro: 'epic',
    title: 'route.Epic',
    background: '#ffffff',
    ...permission.epicPage,
    simple: true
  }
}, {
  name: 'gantt',
  path: '/project/gantt',
  icon: 'zkicon icongonggeshitu',
  meta: {
    micro: 'epic',
    title: 'route.gantt',
    background: '#ffffff',
    ...permission.ganttPage,
    simple: true
  }
}, {
  name: 'project-cicd',
  path: '/project/cicd',
  icon: 'zkicon iconjicheng',
  meta: {
    micro: 'project',
    title: 'route.Jenkins',
    background: '#f6f6f9',
    ...permission.cicdPage,
    simple: true
  }
}, {
  name: 'project-overview',
  path: '/project/overview',
  icon: 'zkicon iconxiangmugailan',
  meta: {
    micro: 'project',
    title: 'route.Overview',
    background: '#f6f6f9',
    ...permission.projectOverview
  }
}, {
  name: 'project-list',
  path: '/project/list',
  icon: 'zkicon icondashboard',
  meta: {
    micro: 'project',
    hidden: true,
    hideHeader: true,
    title: 'route.Projects',
    background: '#f5f5f7',
    simple: true
  }
}, {
  name: 'project-auth-placeholder',
  path: '/project/project-auth-placeholder',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'Projects',
    simple: true
  }
}, {
  name: 'project-create',
  path: '/project/create',
  meta: {
    micro: 'project',
    hidden: true,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'project-smart-assistant',
  path: '/project/automation',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'setting.smartAssistant',
    background: '#ffffff',
    ...permission.automationPage,
    simple: true,
    noAccessUrl: 'project-auth-placeholder'
  }
}, {
  name: 'project-smart-assistant-detail',
  path: '/project/automation/detail',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'setting.smartAssistant',
    background: '#ffffff',
    ...permission.automationPage,
    simple: true,
    noAccessUrl: 'project-auth-placeholder'
  }
}, {
  name: 'project-member',
  path: '/project/member',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'setting.projectMember',
    background: '#ffffff',
    ...permission.projectMemberPage,
    simple: true
  }
}, {
  name: 'project-department',
  path: '/project/department',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'setting.setting.project.member.groups',
    background: '#ffffff',
    ...permission.projectMemberGroupPage,
    simple: true
  }
}, {
  name: 'project-issue-type',
  path: '/project/worktype',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'setting.issuetype',
    background: '#ffffff',
    ...permission.projectIssueTypePage,
    simple: true
  }
}, {
  name: 'project-workflow',
  path: '/project/workflow',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'setting.workflow',
    background: '#ffffff',
    ...permission.projectWorkflowPage,
    simple: true
  }
}, {
  name: 'project-workflow-detail',
  path: '/project/workflow/detail',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'setting.workflow',
    background: '#ffffff',
    ...permission.projectWebhookPage,
    simple: true
  }
}, {
  name: 'project-function-switch',
  path: '/project/features',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'setting.functionSwitch',
    background: '#ffffff',
    ...permission.projectFeaturesPage,
    simple: true
  }
}, {
  name: 'project-issue-visibility',
  path: '/project/issue-visibility',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'project.issueVisibility.title',
    background: '#ffffff',
    ...permission.projectIssueVisibilityPage,
    simple: true
  }
}, {
  name: 'project-webhook',
  path: '/project/webhook',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'setting.webHook',
    background: '#ffffff',
    ...permission.projectWebhookPage,
    simple: true
  }
}, {
  name: 'project-webhook-detail',
  path: '/project/webhook/detail',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'setting.webHook',
    background: '#ffffff',
    ...permission.projectWebhookPage,
    simple: true
  }
}, {
  name: 'project-webhook-create',
  path: '/project/webhook/create',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'setting.webHook',
    background: '#ffffff',
    ...permission.projectWebhookPage,
    simple: true
  }
}, {
  name: 'project-usage-logs',
  path: '/project/log',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'project.UsageLogs.usageLogs',
    background: '#ffffff',
    ...permission.projectLogsPage,
    simple: true
  }
}, {
  name: 'project-labels',
  path: '/project/tags',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'project.setting.label',
    background: '#ffffff',
    ...permission.projectTagsPage,
    simple: true
  }
},
{
  name: 'project-permission',
  path: '/project/permission',
  meta: {
    micro: 'project',
    hidden: true,
    title: 'org.route.permissionAssignment',
    background: '#ffffff',
    ...permission.projectPermission,
    simple: true
  }
}, {
  name: 'setting-list',
  path: '/setting/fields',
  icon: 'zkicon iconsetting',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    ...permission.systemFieldMgr,
    hideAside: true,
    hideHeader: true,
    simple: true,
    noAccessUrl: 'insights'
  }
}, {
  name: 'Personalization',
  path: '/setting/personalization',
  icon: 'zkicon icongexinghuapeizhi',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    ...permission.customAlias,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'ApiManagement',
  path: '/setting/api',
  // eslint-disable-next-line spellcheck/spell-checker
  icon: 'zkicon iconAPIguanli-01',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    ...permission.mgrApi,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'import',
  path: '/setting/import',
  icon: 'zkicon icondaoru',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    ...permission.systemImport,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'jira',
  path: '/setting/import/jira',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    ...permission.systemImport,
    simple: true
  }
}, {
  name: 'IntegrationType',
  path: '/setting/integration',
  icon: 'zkicon icongongnengkaiguan',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integration
  }
}, {
  name: 'weCom',
  path: '/setting/integration/we-com',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    ...permission.integrationWechat,
    simple: true
  }
}, {
  name: 'dingTalk',
  path: '/setting/integration/ding-talk',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationDingTalk
  }
}, {
  name: 'lark',
  path: '/setting/integration/lark',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationFeiShu
  }
}, {
  name: 'slack',
  path: '/setting/integration/slack',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationSlack
  }
}, {
  name: 'teams',
  path: '/setting/integration/teams',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationTeams
  }
}, {
  name: 'zoom',
  path: '/setting/integration/zoom',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationZoom
  }
}, {
  name: 'gitLab',
  path: '/setting/integration/gitlab',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationGitLab
  }
}, {
  name: 'foxLab',
  path: '/setting/integration/foxLab',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationFoxLab
  }
}, {
  name: 'gitHub',
  path: '/setting/integration/github',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationGitHub
  }
}, {
  name: 'jenkins',
  path: '/setting/integration/jenkins',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationJenkins
  }
}, {
  name: 'coding',
  path: '/setting/integration/coding',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationCoding
  }
}, {
  name: 'codeUp',
  path: '/setting/integration/codeUp',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationCodeUp
  }
}, {
  name: 'sentry',
  path: '/setting/integration/sentry',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationSentry
  }
}, {
  name: 'sentryAuth',
  path: '/setting/integration/sentry/authorization',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'notion',
  path: '/setting/integration/notion',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationNotion
  }
}, {
  name: 'notionAuth',
  path: '/setting/integration/notion/authorization',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'zapier',
  path: '/setting/integration/zapier',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationZapier
  }
}, {
  name: 'figma',
  path: '/setting/integration/figma',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationFigma
  }
}, {
  name: 'LDAP',
  path: '/setting/integration/LDAP',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationLdap
  }
}, {
  name: 'SamlAzureAD',
  path: '/setting/integration/saml-azure-ad',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true,
    ...permission.integrationSamlAzureAD
  }
}, {
  name: 'WorkingDays',
  // eslint-disable-next-line spellcheck/spell-checker
  path: '/setting/workingdays',
  icon: 'zkicon iconzuzhishiqu',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    ...permission.settingWorkingDay,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'OrgInfo',
  path: '/setting/orginfo',
  icon: 'zkicon iconjibenxinxi',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    ...permission.orgInfo,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'personnel',
  path: '/setting/members',
  icon: 'zkicon iconrenyuanguanli',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    ...permission.settingMemberView,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'GroupManage',
  path: '/setting/members/group-manage',
  icon: 'zkicon iconrenyuanguanli',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    ...permission.settingMemberGroupView,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'PermissionAssignment',
  path: '/setting/permission',
  icon: 'zkicon iconshouquanguanli',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    ...permission.settingPermissionReadonlyOrMgr,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'SubscriptionsMana',
  path: '/setting/subscription',
  icon: 'zkicon iconshouquanguanli',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    ...permission.settingSubscription,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'AuditLog',
  path: '/setting/audit-log',
  icon: 'zkicon iconwendang2',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    ...permission.settingAuditLog,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'AiTokenReport',
  path: '/setting/ai-token-report',
  icon: 'zkicon iconTrend',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'aiTokenReport.title',
    background: '#f6f6f9',
    ...permission.settingAiTokenReport,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'OrderList',
  path: '/setting/billing',
  icon: 'zkicon iconshouquanguanli',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    ...permission.settingBilling,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'OrderDetail',
  path: '/setting/billing/detail',
  icon: 'zkicon iconshouquanguanli',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    ...permission.settingBilling,
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'personal-centre',
  path: '/setting/account',
  icon: 'zkicon icongerenzhongxin',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'messageSetting',
  path: '/setting/notification',
  icon: 'zkicon icontongzhishezhi',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'emailPreferences',
  path: '/setting/email-preferences',
  icon: 'zkicon iconyoujianyaoqing',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'personal-api',
  path: '/setting/api-key',
  icon: 'zkicon iconmiyaoguanli',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'recorder-file',
  path: '/setting/recorder',
  meta: {
    micro: 'setting',
    hidden: true,
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    ...permission.settingRecorder,
    simple: true
  }
}, {
  name: 'menu',
  path: '/setting/menu',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'laboratory',
  path: '/setting/laboratory',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    simple: true
  }
}, {
  name: 'recycleBin',
  path: '/setting/recycle-bin',
  meta: {
    micro: 'setting',
    hidden: true,
    title: 'route.Setting',
    background: '#f6f6f9',
    hideAside: true,
    hideHeader: true,
    ...permission.recycleBin,
    simple: true
  }
}];
